import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UpcomingEventsCard = ({ events }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = date?.toLocaleDateString('en-US', { month: 'short' });
    const day = date?.getDate();
    return { month, day };
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  };

  return (
    <div className="bg-card rounded-xl p-6 shadow-md border border-border">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-foreground flex items-center gap-2">
          <Icon name="Calendar" size={24} className="text-secondary" />
          Upcoming Events
        </h2>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/event-experience-hub')}
          iconName="ArrowRight"
          iconPosition="right"
        >
          View All
        </Button>
      </div>
      <div className="space-y-3">
        {events?.map((event) => {
          const { month, day } = formatDate(event?.date);
          return (
            <div
              key={event?.id}
              className="flex gap-4 p-4 rounded-lg border border-border hover:border-secondary hover:shadow-md transition-all cursor-pointer group"
              onClick={() => navigate('/event-experience-hub')}
            >
              <div className="flex-shrink-0 w-16 h-16 rounded-lg bg-secondary/10 flex flex-col items-center justify-center border border-secondary/20">
                <span className="text-xs font-semibold text-secondary uppercase">{month}</span>
                <span className="text-2xl font-bold text-secondary">{day}</span>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-foreground mb-1 group-hover:text-secondary transition-colors line-clamp-1">
                  {event?.title}
                </h3>
                <div className="flex flex-wrap items-center gap-3 text-sm text-muted-foreground mb-2">
                  <span className="flex items-center gap-1">
                    <Icon name="Clock" size={14} />
                    {formatTime(event?.date)}
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="MapPin" size={14} />
                    {event?.location}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="flex items-center gap-1 text-xs text-muted-foreground">
                    <Icon name="Users" size={14} />
                    {event?.attendees} attending
                  </span>
                  {event?.spotsLeft && (
                    <span className="text-xs font-medium text-accent bg-accent/10 px-2 py-1 rounded-full">
                      {event?.spotsLeft} spots left
                    </span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UpcomingEventsCard;